import Cookies from 'js-cookie';
import actions from './actions';
import { NccgDataService } from '../../config/dataService/nccgDataservice';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const DEFAULT_ADMIN_ID = 'e6d8883f-83be-4b61-aff0-5156fdd2e691';

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await NccgDataService.post('/smip/auth/login', values);
      // console.log(response.data);

      if (response.data && response.data.user && response.data.userType) {
        const { user, userType, details } = response.data;

        // Initialize all IDs as null
        const userIds = {
          adminId: null,
          borrowerId: null,
          investorId: null,
          facilitatorId: null,
        };

        // Handle admin case separately
        if (userType === 'admin') {
          userIds.adminId = DEFAULT_ADMIN_ID;
        }
        // For other user types, check details as before
        else if (details && details.length > 0) {
          const detail = details[0];
          switch (userType) {
            case 'borrower':
              userIds.borrowerId = detail.id;
              break;
            case 'investor':
              userIds.investorId = detail.id;
              break;
            case 'facilitator':
              userIds.facilitatorId = detail.id;
              break;
            default:
              break;
          }
        }

        // Store in cookies
        Cookies.set('access_token', user.id);
        Cookies.set('userType', userType);
        Cookies.set('logedIn', 'true');

        // Store IDs in cookies
        Object.entries(userIds).forEach(([key, value]) => {
          if (value) {
            Cookies.set(key, value);
          }
        });

        // Dispatch success with user type and IDs
        dispatch(
          loginSuccess({
            login: true,
            userType,
            ...userIds,
          }),
        );

        if (callback) {
          callback(userType);
        }
      } else {
        throw new Error('Invalid credentials');
      }
    } catch (err) {
      let errorMessage = 'Login failed';

      // Check for error response from API
      if (err.response && err.response.data) {
        // This will capture the "Invalid credentials" message from the API
        errorMessage = err.response.data.message || errorMessage;
      } else if (err.message) {
        errorMessage = err.message;
      }

      dispatch(loginErr(errorMessage));
    }
  };
};

const register = (values) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await NccgDataService.post('/smip/users', values);

      if (response.data?.data) {
        // Registration successful but don't log in automatically
        dispatch(
          loginSuccess({
            login: false,
            userType: null,
            adminId: null,
            borrowerId: null,
            investorId: null,
            facilitatorId: null,
          }),
        );
      } else {
        throw new Error('Registration failed!');
      }
    } catch (err) {
      let errorMessage = 'Registration failed';
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }
      dispatch(loginErr(errorMessage));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      // Remove all auth-related cookies
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      Cookies.remove('userType');
      Cookies.remove('adminId');
      Cookies.remove('borrowerId');
      Cookies.remove('investorId');
      Cookies.remove('facilitatorId');

      dispatch(logoutSuccess(false));
      if (callback) {
        callback();
      }
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut, register };
